export function parseCustomerSettings(settingsJson: unknown): Record<string, any> {
  if (!settingsJson) {
    return {};
  }
  if (typeof settingsJson === "object" && !Array.isArray(settingsJson)) {
    return { ...(settingsJson as Record<string, any>) };
  }
  if (typeof settingsJson === "string") {
    try {
      const parsed = JSON.parse(settingsJson);
      return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
    } catch {
      return {};
    }
  }
  return {};
}

export function isRootCustomer(customer: { name?: string } | null | undefined): boolean {
  return String(customer?.name || "").toLowerCase() === "root";
}

export function isMspOrgCustomer(customer: { settings_json?: any; is_msp_org?: boolean } | null | undefined): boolean {
  if (!customer) {
    return false;
  }
  if (customer.is_msp_org === true) {
    return true;
  }
  const settings = parseCustomerSettings(customer.settings_json);
  return settings.is_msp_org === true || settings.is_msp_org === 1 || settings.is_msp_org === "true";
}

/** Hide from PSA customer pickers: root ("All") is handled separately; MSP org is never a billable client. */
export function isMspOrgOrHiddenCustomer(
  customer: { name?: string; settings_json?: any; is_msp_org?: boolean } | null | undefined
): boolean {
  return isRootCustomer(customer) || isMspOrgCustomer(customer);
}
